export default __webpack_public_path__ + "static/media/c4ca5c2b-863d-450e-8df2-6cf8d40a6d9b.2aa8abe5.woff2";